<template>
  <component
    :is="transitionElement"
    class="ui-loading-container"
    :class="classList"
    name="fade"
    :mode="transitionMode"
  >
    <div
      v-if="isOpen"
      class="ui-loading-layout"
      :class="classList"
    >
      <svg
        v-if="colorCircle"
        class="ui-loading"
        :width="defineSize.width"
        :height="defineSize.height"
      >
        <defs>
          <linearGradient id="gradient">
            <stop
              offset="0"
              :stop-color="colorCircle"
            />
            <stop
              offset="100%"
              :stop-color="shaderColor(colorCircle, 40)"
            />
          </linearGradient>
        </defs>
        <circle
          fill="transparent"
          :r="defineSize.r"
          :cx="defineSize.x"
          :cy="defineSize.y"
          stroke="url(#gradient)"
          :stroke-width="defineSize.sw"
        />
      </svg>
      <div v-if="text" class="ui-loading-text">
        {{ text }}
      </div>
    </div>
  </component>
</template>

<script>

import { shaderColor } from '../../libs/helpTools'
import { SIZES } from '../../libs/helpConsts'
import colors from '../../libs/colors'

const TYPES = {
  GLOBAL: 'global',
  ABSOLUTE: 'absolute'
}

export default {
  name: 'UiLoading',
  props: {
    size: {
      type: String,
      default: 'm',
      // TODO: переделать на SIZES
      validator (size) {
        if (!size) return true
        return ['m', 'big', 'small'].includes(size)
      }
    },
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: '',
      validator (type) {
        if (!type) return true
        return Object.values(TYPES).includes(type)
      }
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    hideTransition: {
      type: Boolean,
      default: false
    },
    transitionMode: {
      type: String,
      default: 'in-out'
    },
    transparent: Boolean
  },
  computed: {
    defineSize () {
      switch (this.size) {
        case 'big':
          return {
            r: 26,
            x: 30,
            y: 30,
            sw: 8,
            width: 60,
            height: 60
          }
        case 'small':
          return {
            r: 8,
            x: 10,
            y: 10,
            sw: 4,
            width: 20,
            height: 20
          }
        case SIZES.M:
        default: {
          return {
            r: 17,
            x: 20,
            y: 20,
            sw: 6,
            width: 40,
            height: 40
          }
        }
      }
    },

    classList () {
      return [
        this.type ? `_type_${this.type}` : null,
        {
          size: this.size,
          'is-global': this.type === 'global',
          _transparent: this.transparent
        }
      ]
    },

    colorCircle () {
      return colors.primary
    },

    transitionElement () {
      return this.hideTransition ? 'div' : 'transition'
    }
  },

  methods: {
    shaderColor
  }
}
</script>
<style lang="scss" scoped>
.ui-loading-container {
  display: contents;
}

.ui-loading {
  animation: spin 2s linear infinite;

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
}

.ui-loading-text {
  margin-top: 10px;
}

.ui-loading-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: rgba($light-01, 0.5);

  &._type {
    &_global {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10000;
    }
    &_absolute {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
  }

  &._transparent {
    background-color: transparent;
  }
}

.fade-leave-active, {
  animation: opacity 0.5s;
}

@keyframes opacity {
  0% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
